import { dayOfWeek, serviceType } from '@/const/shared'

export function sorter(data, type) {
  const ordering = {
    days: {
      [dayOfWeek.MONDAY]: 1,
      [dayOfWeek.TUESDAY]: 2,
      [dayOfWeek.WEDNESDAY]: 3,
      [dayOfWeek.THURSDAY]: 4,
      [dayOfWeek.FRIDAY]: 5,
      [dayOfWeek.SATURDAY]: 6,
      [dayOfWeek.SUNDAY]: 7
    },
    service: {
      [serviceType.EYE_TEST]: 1,
      [serviceType.CONTACT_LENS]: 2,
      [serviceType.PRODUCTS]: 3,
      [serviceType.HEARING_TEST]: 4,
      [serviceType.LOW_VISION]: 5
    }
  }
  const typeSorter = ordering[type]
  let dataOrdered = [...data]
  dataOrdered.sort((a, b) => typeSorter[a.key] - typeSorter[b.key])
  return dataOrdered
}

export function division(firstVal, secondVal) {
  if (firstVal % secondVal !== 0) {
    return (firstVal / secondVal).toFixed(2)
  } else {
    return firstVal / secondVal
  }
}
